import React from 'react';
import styles from './BoardModeTabs.module.css';

export default function BoardModeTabs({ activeMode = '2d', onSelect2D, onSelect3D, className = '' }) {
  return (
    <div className={`${styles.tabs} ${className}`.trim()} role="tablist" aria-label="Board view">
      <button
        type="button"
        role="tab"
        aria-selected={activeMode === '2d'}
        className={activeMode === '2d' ? styles.active : ''}
        onClick={onSelect2D}
        title="Open normal 2D board"
      >
        2D
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={activeMode === '3d'}
        className={activeMode === '3d' ? styles.active : ''}
        onClick={onSelect3D}
        title="Open 3D board"
      >
        3D
      </button>
    </div>
  );
}
